/* eslint-disable no-unused-vars */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import * as S from './CustomButton.styled';

export const Colors = {
  Primary: 'BUTTON_PRIMARY',
  Secondary: 'BUTTON_SECONDARY',
  Tertiary: 'BUTTON_TERTIARY',
  Delete: 'BUTTON_DELETE',
};

// eslint-disable-next-line react/display-name
const CustomButton = React.memo(
  forwardRef(
    (
      {
        form,
        id,
        type = 'button',
        name,
        buttonColor,
        onClick,
        fullWidth,
        icon,
        disabled,
        children,
        isMutedTertiary,
        square,
        customStyle,
        btnWrapperStyle,
        containerStyle,
        iconStyle,
        pressed,
      },
      ref,
    ) => {
      return (
        <S.Container ref={ref} fullWidth={fullWidth} style={containerStyle}>
          <S.StyledButonWrapper
            isIcon={!!children}
            buttonColor={buttonColor}
            isMutedTertiary={isMutedTertiary}
            square={square}
            btnWrapperStyle={btnWrapperStyle}
            isPressed={pressed}
          >
            <S.StyledButton
              form={form}
              id={id}
              type={type}
              name={name}
              color='inherit'
              onClick={onClick}
              variant='contained'
              fullWidth={fullWidth}
              disabled={disabled}
              sx={customStyle}
            >
              {icon && (
                <S.IconWrapper style={iconStyle} isIcon={!!children}>
                  {icon}
                </S.IconWrapper>
              )}
              {children}
            </S.StyledButton>
          </S.StyledButonWrapper>
        </S.Container>
      );
    },
  ),
);
CustomButton.displayName = 'CustomButton';

CustomButton.Colors = {
  ...Colors,
};

CustomButton.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  type: PropTypes.string,
  buttonColor: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  icon: PropTypes.node,
  disabled: PropTypes.bool,
  isMutedTertiary: PropTypes.bool,
  form: PropTypes.string,
};

export default CustomButton;
